import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { Customer } from 'src/app/modules/customer/interfaces/customer';
import { CustomerService } from 'src/app/modules/customer/services/customer.service';
import { FormControl } from '@angular/forms';
import { CustomerType } from 'src/app/modules/customer/interfaces/customer-type';

@Component({
  selector: 'autocomplete-customer',
  templateUrl: './autocomplete-customer.component.html',
  styleUrls: ['./autocomplete-customer.component.css'],
})

export class AutoCompleteCustomerComponent {

  @Output()
  public customerEmitter = new EventEmitter<Customer>();

  @Input()
  customerType: number = CustomerType.INSURED_CUSTOMER;

  @Input()
  hideIds: number[] = [];

  @Output()
  public clearEmitter = new EventEmitter<boolean>();

  private searchResults: Customer[] = [];

  control = new FormControl();

  selectedCustomers: Customer[];

  constructor(private customerService: CustomerService) { }

  public searchCustomer = ($text: Observable<string>) => {
    return $text.pipe(
      debounceTime(200),
      map(term => this.search(term))
    );
  }

  public search = (term: string) => {
    if (term === '') {
      return [];
    }

    this.customerService.searchAutocomplete(term, this.customerType)
      .then((value: Customer[]) => {
        this.searchResults = this.filterHideIds(value);
      }).catch(err => console.log('Fehler: ', err));
    return this.searchResults;
  }

  public formatter = (x: Customer) => {
    if (x.Type === CustomerType.INSURED_CUSTOMER) {
      return  x.Person.LastName + ', ' + x.Person.FirstName + ', ' + x.InsuranceNumber;
    }

    return  x.Person.LastName + ', ' + x.Person.FirstName;
  };

  filterHideIds(customers: Customer[]): Customer[] {
    if (this.hideIds.length === 0) {
      return customers;
    }

    return customers.filter((customer: Customer) => {
      return (this.hideIds.includes(customer.Id) === false);
    });
  }

  /**
   * Übermittelt den ausgewählten Kunden an das Elternelement.
   *
   * @param $event: any
   */
  public selectCustomer = ($event) => {
    this.customerEmitter.emit($event.item);
  }

  public clear() {
    this.control.setValue(null);
    this.clearEmitter.emit(true);
  }

}
